import type { SupplementData } from "@qendo/medical/supplement";
import { MedicalType } from "@qendo/medical/types";
import type { DosageData } from "@qendo/medication";
import type { ScheduleData } from "@qendo/schedule";
import Data from "~/util/data";

export class Supplement extends Data implements SupplementData {
    public readonly type = MedicalType.supplement;

    public constructor(
        public id?: string,
        public current = false,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public dosage: DosageData | null = null,
        public schedule: ScheduleData | null = null,
    ) {
        super();
    }
}
